import { render, staticRenderFns } from "./TotpVerify.vue?vue&type=template&id=39e74b55&scoped=true&"
import script from "./TotpVerify.vue?vue&type=script&lang=js&"
export * from "./TotpVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e74b55",
  null
  
)

export default component.exports